<ng-container #lazyLoadComponent />
